// chakra imports
import { Box, Flex, Stack, Button, Text, useColorModeValue } from "@chakra-ui/react";
import Links from "components/sidebar/components/Links";
import React from "react";
import { MdExitToApp } from "react-icons/md";
import { signOut } from "@aws-amplify/auth";
import { useNavigate } from "react-router-dom";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  const navigate = useNavigate();
  const textColor = useColorModeValue("navy.700", "white");
  
  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/auth/sign-in");
    } catch (error) {
      console.error("Error signing out:", error);
      navigate("/auth/sign-in");
    }
  };
  
  return (
    <Flex direction='column' height='100%' pt='25px' px="16px" borderRadius='30px'>
      <img
        src="https://app.enqelt.com/wp-content/uploads/2024/09/cropped-Untitled-project_4.jpg"
        alt="Enqelt Logo"
        style={{ width: "100px", height: "auto" }}
      />
      <Stack direction='column' mb='auto' mt='8px'>
        <Box ps='20px' pe={{ md: "16px", "2xl": "1px" }}>
          <Links routes={routes} />
        </Box>
      </Stack>
      
      {/* Logout Button */}
      <Box mt="auto" mb="20px" ps="20px">
        <Button
          leftIcon={<MdExitToApp />}
          variant="ghost"
          justifyContent="flex-start"
          width="100%"
          py="12px"
          onClick={handleLogout}
          _hover={{
            bg: "rgba(0, 0, 0, 0.08)",
          }}
          borderRadius="lg"
        >
          <Text color={textColor} fontWeight="bold">
            Logout
          </Text>
        </Button>
      </Box>
    </Flex>
  );
}

export default SidebarContent;